import { PaymentFrequency } from 'scenes/common/types';
import { CoverOptionsData } from 'scenes/motor/types';

export const defaultCoverOptions: CoverOptionsData = {
  preselectedPaymentFrequency: PaymentFrequency.Annually,
  selectedExtras: [],
};
